module.exports = require("@swa-ui/browser/src/assets/styles/gridDefines.module.scss");